<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Debug de Autenticação</h4>
            
            <!-- Estado Atual -->
            <div class="row mb-4">
              <div class="col-md-6">
                <h5>Estado LocalStorage</h5>
                <div class="bg-light p-3 rounded">
                  <p><strong>User:</strong></p>
                  <pre>{{ JSON.stringify(authState.user, null, 2) }}</pre>
                  
                  <p><strong>UserInfo:</strong></p>
                  <pre>{{ JSON.stringify(authState.userInfo, null, 2) }}</pre>
                </div>
              </div>
              
              <div class="col-md-6">
                <h5>Estado Computed</h5>
                <div class="bg-light p-3 rounded">
                  <p><strong>Role Atual:</strong> {{ currentUserRole }}</p>
                  <p><strong>É Admin:</strong> {{ isAdmin ? 'Sim' : 'Não' }}</p>
                  <p><strong>É Doutor:</strong> {{ isDoctor ? 'Sim' : 'Não' }}</p>
                  <p><strong>É Técnico:</strong> {{ isTechnician ? 'Sim' : 'Não' }}</p>
                  <p><strong>É Paciente:</strong> {{ isPatient ? 'Sim' : 'Não' }}</p>
                </div>
              </div>
            </div>
            
            <!-- Teste de Permissões -->
            <div class="row mb-4">
              <div class="col-12">
                <h5>Teste de Permissões</h5>
                <div class="table-responsive">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Rota</th>
                        <th>Role Requerido</th>
                        <th>Tem Acesso</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="route in testRoutes" :key="route.path">
                        <td>{{ route.path }}</td>
                        <td>{{ route.requiredRole }}</td>
                        <td>{{ canAccess(route.requiredRole) ? 'Sim' : 'Não' }}</td>
                        <td>
                          <span :class="canAccess(route.requiredRole) ? 'badge bg-success' : 'badge bg-danger'">
                            {{ canAccess(route.requiredRole) ? 'Permitido' : 'Negado' }}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            
            <!-- Ações -->
            <div class="row">
              <div class="col-12">
                <h5>Ações de Debug</h5>
                <button @click="syncAuth" class="btn btn-primary me-2">
                  Sincronizar Auth
                </button>
                <button @click="refreshState" class="btn btn-secondary me-2">
                  Atualizar Estado
                </button>
                <button @click="testNavigation" class="btn btn-info me-2">
                  Testar Navegação Admin
                </button>
                <button @click="clearAuth" class="btn btn-danger">
                  Limpar Auth
                </button>
              </div>
            </div>
            
            <!-- Menu Items Debug -->
            <div class="row mt-4">
              <div class="col-12">
                <h5>Itens de Menu Disponíveis</h5>
                <div class="bg-light p-3 rounded">
                  <pre>{{ JSON.stringify(filteredMenuItems, null, 2) }}</pre>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { syncLocalStorageAuth } from '@/utils/authSync';
import { filterMenuByRole } from '@/utils/menuPermissions';
import { menuItems } from '@/components/menu';

export default {
  page: {
    title: "Debug Autenticação",
    meta: [{ name: "description", content: "Página de debug para sistema de autenticação" }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Debug Autenticação",
      items: [
        {
          text: "Administração",
          href: "/admin",
        },
        {
          text: "Debug Auth",
          active: true,
        },
      ],
      testRoutes: [
        { path: '/admin/dashboard', requiredRole: 'admin' },
        { path: '/admin/dashboard-advanced', requiredRole: 'admin' },
        { path: '/admin/users', requiredRole: 'admin' },
        { path: '/doctor/exams', requiredRole: 'doctor' },
        { path: '/technician/upload-dicom', requiredRole: 'technician' },
        { path: '/patient/my-exams', requiredRole: 'patient' },
      ]
    };
  },
  computed: {
    filteredMenuItems() {
      // Use the updated filterMenuByRole function from menuPermissions
      return filterMenuByRole(menuItems, this.currentUserRole);
    }
  },
  methods: {
    syncAuth() {
      const result = syncLocalStorageAuth();
      if (result) {
        this.$toast.success('Dados sincronizados com sucesso!');
        this.refreshState();
      } else {
        this.$toast.info('Nenhuma sincronização necessária');
      }
    },
    
    refreshState() {
      this.refreshAuthState();
      this.$toast.info('Estado atualizado');
    },
    
    testNavigation() {
      if (this.isAdmin) {
        this.$router.push('/admin/dashboard-advanced');
      } else {
        this.$toast.error('Você não tem permissão de admin');
      }
    },
    
    clearAuth() {
      localStorage.removeItem('user');
      localStorage.removeItem('userInfo');
      this.$toast.warning('Dados de autenticação removidos');
      this.refreshState();
    }
  }
};
</script>

<style scoped>
pre {
  max-height: 200px;
  overflow-y: auto;
  font-size: 12px;
}

.table th,
.table td {
  font-size: 14px;
}
</style>
